/**
 * AI.GEN lines=1-80
 * i18n 国际化配置
 */
import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import { LanguageEnum, supportedLanguages } from './config';
import enUS from './locales/en-US.json';
import frFR from './locales/fr-FR.json';
import jaJP from './locales/ja-JP.json';
import koKR from './locales/ko-KR.json';
// 导入语言资源
import zhCN from './locales/zh-CN.json';

// 语言资源
const resources = {
  [LanguageEnum.ZhCN]: {
    translation: zhCN,
  },
  [LanguageEnum.EnUS]: {
    translation: enUS,
  },
  [LanguageEnum.FrFR]: {
    translation: frFR,
  },
  [LanguageEnum.JaJP]: {
    translation: jaJP,
  },
  [LanguageEnum.KoKR]: {
    translation: koKR,
  },
};

/**
 * 检查字符串是否为有效的语言枚举值
 */
const isValidLanguage = (value: string | null): value is LanguageEnum => {
  if (value === null) {
    return false;
  }
  return (supportedLanguages as readonly string[]).includes(value);
};

/**
 * AI.GEN lines=1-10
 * 根据 URL 参数、localStorage 获取默认语言，URL 无参数时默认中文
 */
const getDefaultLanguage = (): LanguageEnum => {
  const urlLanguage = new URLSearchParams(window.location.search).get(
    'language',
  );
  const savedLanguage = localStorage.getItem('i18nextLng');
  const language =
    (isValidLanguage(urlLanguage) && urlLanguage) ||
    (isValidLanguage(savedLanguage) && savedLanguage) ||
    LanguageEnum.ZhCN;
  localStorage.setItem('i18nextLng', language);
  return language;
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    lng: getDefaultLanguage(),
    fallbackLng: LanguageEnum.ZhCN,
    supportedLngs: supportedLanguages,
    interpolation: {
      escapeValue: false, // React 已经转义了
    },
    detection: {
      // 禁用自动检测，URL 无参数时默认中文
      order: [],
      caches: ['localStorage'],
    },
  });

export default i18n;
